// @flow
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useHistory } from "react-router-dom";
import CheckAllBig from "../../../assets/images/icons/sideMenu/checkAllBig";
import { Permissions } from "../../../helpers/constants";
import useMenuAction from "../../../hooks/menu/useMenuAction";
import useQueryParams from "../../../hooks/useQueryParams";
import { useHasPermission } from "../../../modules/permission/hooks/useHasPermission";
import type { FAQ } from "../../../types/exhibition/types";
import { ListItem, ListItemButton } from "@mui/material";
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from "@mui/material/ListItemText";
import { getRouteUrl } from "../../../helpers/getRouteUrl";
import { ROUTE_PAGE_EXHIBITION } from "../../../routers/routes";
import { useTranslation } from "react-i18next";
import { EXHIBITION } from "../../../locales/components/namespaces";

type Props = {
	exhibitionId: string,
	item: FAQ,
}

const ViewRow = ((props: Props) => {
	const history = useHistory();
	const { t } = useTranslation(EXHIBITION)
	const { item: { id, title, isNew }, exhibitionId, depth } = props
	const queryParams = useQueryParams()
	const theme = useTheme()
	const faqId = queryParams.get('faqId') ?? ""
	const selected = Number(faqId) === id
	const isOrganizer = useHasPermission([Permissions.BeOrganizer], { shouldView: true })
	const {setMenuActiveItem} = useMenuAction()
	return (
		<ListItem
			disableGutters
			onClick={(event) => event.stopPropagation()}
		>
			<ListItemButton
				selected={selected}
				sx={{
					pl: (depth + 1) * 2,
					color: '#616a6f',
					'&.Mui-selected': {
						borderRadius: '12px',
						background: theme.palette.highlight.dark,
						boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.20) inset',
						span: {
							color: '#fff'
						},
						'&:hover': {
							borderRadius: '12px',
							background: theme.palette.highlight.dark,
							boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.20) inset',
							span: {
								color: '#fff'
							}
						}
					},
				}}
				onClick={(event) => {
					event.stopPropagation()
					if(!isOrganizer) {
						setMenuActiveItem(null)
					}
					history.push(getRouteUrl(ROUTE_PAGE_EXHIBITION, {
						id: exhibitionId
					}, {
						faqId: id,
					}))
				}}
			>
				{depth > 0 ? (
					<ListItemIcon sx={{ paddingRight: 2, minWidth: 24 }}>
						<CheckAllBig color={'#5E666B'}/>
					</ListItemIcon>
				) : null}
				<ListItemText
					sx={{ whiteSpace: "initial" }}
					slotProps={{
						primary: {
							variant: "body1",
							component: 'span'
						}
					}}
					primary={isNew ? <span>{title}<sup style={{
						color: '#d32f2f',
						paddingLeft: '4px',
						fontWeight: 'bold'
					}}>{t('NEW')}</sup></span> : title}
				/>
			</ListItemButton>
		</ListItem>
	)
})

export default ViewRow
